import HomeView from './pages/HomeView.vue'
import LoginView from './pages/LoginView.vue'
import SearchView from './pages/SearchView.vue'
import CouponView from './pages/CouponView.vue'
import ProductDetailView from './pages/ProductDetailView.vue'
import CommissionView from './pages/CommissionView.vue'
import HistoryView from './pages/HistoryView.vue'
import SettlementDetailView from './pages/SettlementDetailView.vue'
import OrderView from './pages/OrderView.vue'
import RankView from './pages/RankView.vue'
import UserView from './pages/UserView.vue'

/** 路由表 */
const routes = [
  { path: '/', meta: { name: '荟创星选', showTabBar: true },  component: HomeView},
  { path: '/login', meta: { name: null, showTabBar: false }, component: LoginView },
  { path: '/search', meta: { name: '搜索', showTabBar: false }, component: SearchView },
  { path: '/coupon/:itemId', meta: { name: '荟创星选', showTabBar: false }, component: CouponView },
  { path: '/productDetail/:skuId', meta: { name: '荟创星选', showTabBar: false }, component: ProductDetailView },
  { path: '/commission', meta: { name: '佣金', showTabBar: true }, component: CommissionView },
  { path: '/historyrecord', meta: { name: '历史记录', showTabBar: false}, component: HistoryView },
  { path: '/settlementDetail/:settlementId', meta: { name: '荟创星选', showTabBar: false}, component: SettlementDetailView },
  { path: '/order', meta: { name: '荟创星选', showTabBar: false}, component: OrderView },
  { path: '/rank', meta: { name: '榜单', showTabBar: true}, component: RankView },
  { path: '/my', meta: { name: '我的', showTabBar: true}, component: UserView }
]

export default routes
